import { CONFIG_ELEMENT_ID, DEFAULT_PROXY_PATH_PREFIX, type ResolvedConfig } from '@nvd/claim-shared';
import { createApi, type Api } from '../api/client';

/**
 * Proxy mode: the server inlines the config next to the root element.
 * Embed mode: the theme block sets `data-api-base` and the config is fetched through the App Proxy.
 */
export async function loadConfig(root: HTMLElement): Promise<{ config: ResolvedConfig; api: Api }> {
  const inline = document.getElementById(CONFIG_ELEMENT_ID)?.textContent;
  if (inline) {
    const config = JSON.parse(inline) as ResolvedConfig;
    return { config, api: createApi(config.apiBase) };
  }

  const apiBase = (root.dataset.apiBase || `${DEFAULT_PROXY_PATH_PREFIX}/api`).replace(/\/+$/, '');
  const api = createApi(apiBase);
  return { config: await api.config(), api };
}
